import React, { Component } from 'react'
import { makeId, get, isset } from '../../helpers/default';

/**
 * @typedef {Object} InputParentProps
 * @property {boolean} [Direct] - Cho biết có bật chế độ trực tiếp hay không.
 * @property {(value: any, self: InputParent) => any} [DecoratorIn] - Hàm xử lý giá trị đầu vào.
 * @property {(value: any, self: InputParent) => any} [DecoratorOut] - Hàm xử lý giá trị đầu ra.
 * @property {(value: any, self: InputParent) => void} [OnChange] - Callback khi giá trị thay đổi.
 * @property {any} [DefaultValue] - Giá trị mặc định.
 * @property {(value: any, self: InputParent) => void} [OnChangeBlur] - Callback khi mất focus và giá trị đã thay đổi.
 */

/**
 * @extends {React.Component<InputParentProps>}
 */

class InputParent extends Component {
	/**
   * @param {InputParentProps} props
   */
	constructor(props) {
	    super(props);
	    
		let defaultVal = this.props.DefaultValue??''
		if(this.props.DecoratorIn) defaultVal = this.props.DecoratorIn(defaultVal, this)
	    this.state = {
	    	value: defaultVal,
	    }

		this.id = makeId();
		this.oldValue = defaultVal;
		this.revert = {};
		this.rent = {};
		
	}

	initial(force={}) {
		this.rent = {}
		for(let key in this.props){
			if(key[0] == key[0].toUpperCase() || force[key]){
				this[key] = this.props[key]
			}else{
				if(key == 'value') continue
				this.rent[key] = this.props[key]
			}
		}

	}

	
	setValue(value){
		return new Promise((resolv, reject)=>{
			// Set value for undirect mode
			if(this.DecoratorIn) value = this.DecoratorIn(value, this);
			if(value == null) value = '';
			this.oldValue = value;
			this.setState({value: value}, ()=>resolv(value));
		})
		
	}
	
	getValue(){
		// Get value for undirect mode
		if(this.props.Direct){
			var value = this.props.value
		}else{
			var value = this.state.value;
		}
		
		if(this.DecoratorOut) value = this.DecoratorOut(value, this);
		return value;
	}

	showValue(){
		// Value to show on dom
		if(this.props.Direct){
			var val = get(this.props.value, '');
			if(this.DecoratorIn) val = this.DecoratorIn(val, this);
		}else{
			var val = this.state.value;
		}
		return val === null ? '' : val
	}
	
	revertValue(value){
		// convert value to option key
		if(this.DecoratorOut) value = this.DecoratorOut(value, this);
		if(isset(this.revert[value])) value = this.revert[value];
		return value;
	}

	onBlurHandle(event){
		if(this.props.onBlur) this.props.onBlur(event);
		let val = event.target.value;
		if(this.DecoratorOut) val = this.DecoratorOut(val, this);
		if(val != this.oldValue){
			if(this.props.OnChangeBlur){
				this.oldValue = val;
				this.props.OnChangeBlur(val, this)
			}
		}
	}

	onChangeHandle(event){
		var val = event.target.value;
		
		if(!this.props.Direct){
			this.setState({'value': val}, ()=>{
				if(this.props.OnChange){
					if(this.DecoratorOut) val = this.DecoratorOut(val, this);
					this.props.OnChange(val, this);
				}
				if(this.loadSuggest) this.loadSuggest()
			})
		}else{
			if(this.props.OnChange){
				if(this.DecoratorOut) val = this.DecoratorOut(val, this);
				this.props.OnChange(val, this);
			}
		}
		
	}

	focus(){
		this.input.focus()
	}
	
}

export default InputParent;